import { mix } from 'polished';
import styled, { css } from 'styled-components';
import { Check } from '@clds/icon';
import { focusVisible } from '@clds/style-utils';
import { checkboxTheme } from './theme.js';
export const StyledCheckIcon = styled(Check) `
  margin-left: -${checkboxTheme.width};
  width: 100%;
  height: 100%;
`;
export const Root = styled.div `
  width: ${checkboxTheme.width};
  height: ${checkboxTheme.height};
  display: inline-block;
  flex-shrink: 0;

  input {
    -webkit-appearance: none;
    cursor: pointer;
    width: 100%;
    height: 100%;

    border-radius: ${checkboxTheme.border.radius};
    transition: 125ms;

    border: 1px solid;
    border-color: ${checkboxTheme.border.color.inactive};
    background-color: ${checkboxTheme.background.color.inactive};

    outline: none;

    &${focusVisible()} {
      outline: none;
      box-shadow: ${checkboxTheme.focus.boxShadow.sizes}
        // eslint-disable-next-line max-len
        ${(props) => mix(0.5, props.theme.palette.primary, props.theme.palette.contrastInvert)};
    }

    &:hover {
      ${({ hasError, isDisabled }) => !hasError &&
    !isDisabled &&
    css `
                border-color ${checkboxTheme.border.color.hover};
              `}
    }
  }

  ${StyledCheckIcon} {
    pointer-events: none;
    color: ${checkboxTheme.icon.color.inactive};
    transform: scale(0);
    transition: transform 200ms cubic-bezier(0.68, 1.51, 0.68, 1.51);
    padding: ${checkboxTheme.icon.padding};
  }

  input:checked {
    ${({ hasError, isDisabled }) => !hasError &&
    !isDisabled &&
    css `
        border-color: ${checkboxTheme.border.color.checked};
        background-color: ${checkboxTheme.background.color.checked};
      `}
    + ${StyledCheckIcon} {
      color: ${checkboxTheme.icon.color.checked};
      transform: scale(1);
    }
  }

  ${({ hasError }) => hasError &&
    css `
      input {
        border-color: ${checkboxTheme.border.color.error};
        background-color: ${checkboxTheme.background.color.inactive};

        &:checked {
          background-color: ${checkboxTheme.background.color.error};
        }

        + ${StyledCheckIcon} {
          color: ${checkboxTheme.icon.color.error};
        }
      }
    `}

  ${({ isDisabled }) => isDisabled &&
    css `
      input {
        border-color: ${checkboxTheme.border.color.disabled};
        background-color: ${checkboxTheme.background.color.inactive};

        &:checked {
          background-color: ${checkboxTheme.background.color.disabled};
        }

        + ${StyledCheckIcon} {
          color: ${checkboxTheme.icon.color.disabled};
        }
      }
    `}
`;
